module.exports = __webpack_public_path__ + "static/logo-university-toronto-2c528821eec00052a12729eec2747007.svg";